var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcTimer24X24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.015 12a9.014 9.014 0 1 1-18.029 0 9.014 9.014 0 0 1 18.029 0Zm-8.526-5.656a.5.5 0 1 0-1 0V12a.5.5 0 0 0 .5.5h4.53a.5.5 0 1 0 0-1h-4.03V6.344Z",
  fill: "#8B97A7"
})));
export default SvgIcTimer24X24;